import { Building2, ClipboardCheck, GraduationCap, MessagesSquare, Presentation, Store } from 'lucide-react'
import * as Icons from '../icons'

export const NAV_DATA = [
  {
    label: '',
    access: [
      'admin',
      'super_admin',
    ],
    items: [
      {
        title: 'Dashboard',
        icon: Icons.HomeIcon,
        color: 'cyan',
        url: '/dashboard',
        items: [],
        access: ['admin', 'super_admin'],
        isPro: true
      },
      {
        title: 'Statistics',
        icon: Icons.PieChart,
        color: 'purple',
        url: '/statistics',
        items: [],
        access: ['super_admin'],
        isPro: true
      },
    ],
  },
  {
    label: 'LEARNING',
    access: [
      'super_admin',
      'support'
    ],
    items: [
      {
        title: 'Lectures',
        icon: Presentation,
        color: 'amber',
        access: ['super_admin', 'support'],
        isPro: true,
        items: [
          {
            title: 'Lectures',
            url: '/lectures',
            access: ['super_admin', 'support'],
          },
          {
            title: 'Add Lecture',
            url: '/lectures/add',
            access: ['super_admin', 'support'],
          },
          {
            title: 'Categories',
            url: '/lectures/categories',
            access: ['super_admin', 'support'],
          },
        ],
      },
      // {
      //   title: 'Teachers',
      //   icon: GraduationCap,
      //   color: 'purple',
      //   access: ['super_admin', 'support'],
      //   isPro: true,
      //   items: [
      //     {
      //       title: 'Teachers',
      //       url: '/teachers',
      //       access: ['super_admin', 'support'],
      //     },
      //     {
      //       title: 'Add Teacher',
      //       url: '/teachers/add',
      //       access: ['super_admin', 'support'],
      //     },
      //   ],
      // },
      {
        title: 'Institutions',
        icon: Building2,
        color: 'green',
        url: '/institutions',
        items: [],
        access: ['super_admin', 'support'],
      },
    ],
  },
  {
    label: 'SUPPORT',
    access: [
      'super_admin',
      'support',
    ],
    items: [
      {
        title: 'Teacher Applications',
        icon: ClipboardCheck,
        color: 'green',
        url: '/teacher-applications',
        items: [],
        access: ['super_admin', 'support'],
      },
      {
        title: 'Support Tickets',
        icon: MessagesSquare,
        color: 'cyan',
        url: '/support',
        items: [],
        access: ['super_admin'],
        isPro: true,
      },
      {
        title: 'Support Users',
        icon: Icons.User,
        color: 'purple',
        access: ['super_admin'],
        items: [
          {
            title: 'Support Users',
            url: '/users/system-support',
            access: ['super_admin'],
          },
          {
            title: 'Add Support User',
            url: '/users/system-support/add',
            access: ['super_admin'],
          },
        ],
      },
    ],
  },
  // {
  //   label: 'USERS',
  //   access: [
  //     'super_admin',
  //   ],
  //   items: [
  //     {
  //       title: 'Admins',
  //       icon: Icons.User,
  //       url: '/users/companies',
  //       items: [],
  //       access: ['super_admin'],
  //     },
  //   ],
  // },
  {
    label: 'DISCOVER',
    access: [
      'super_admin',
    ],
    items: [
      {
        title: 'Businesses',
        icon: Store,
        color: 'pink',
        access: ['super_admin'],
        items: [
          {
            title: 'Businesses',
            url: '/discover/businesses',
            access: ['super_admin'],
          },
          {
            title: 'Add Business',
            url: '/discover/businesses/add',
            access: ['super_admin'],
          },
          {
            title: 'Categories',
            url: '/discover/categories',
            access: ['super_admin'],
          },
        ],
      },
    ],
  },
  {
    label: 'MARKETING',
    access: [
      'super_admin'
    ],
    items: [
      // {
      //   title: 'Loyalty Program',
      //   access: ['super_admin'],
      //   items: [
      //     {
      //       title: 'Manage Rules',
      //       url: '/loyalty-program',
      //       access: ['super_admin'],
      //     },
      //     {
      //       title: 'Total Rewards Amount',
      //       url: '/loyalty-program/total',
      //       access: ['super_admin'],
      //     },
      //     {
      //       title: 'Rewards History',
      //       url: '/loyalty-program/history',
      //       access: ['super_admin'],
      //     },
      //   ],
      //   icon: Icons.CoinIcon,
      // },
      {
        title: 'Campaigns',
        url: '/campaigns',
        items: [],
        access: ['super_admin'],
        icon: Icons.Inbox,
      },
      {
        title: "Contacts",
        access: ['super_admin'],
        items: [
          {
            title: "Contacts",
            url: "/contacts-email",
            access: ['super_admin'],
            items: [],
            icon: Icons.ContactIcon,
            color: 'green',
          },
          {
            title: "Email Subscriptions",
            url: "/email-subscriptions",
            access: ['super_admin'],
            items: [],
            icon: Icons.Inbox,
            color: 'amber',
          },
        ],
        icon: Icons.ContactIcon,
        color: 'green',
      },
      // {
      //   title: 'Push Notifications',
      //   icon: Icons.BellIcon,
      //   access: ['super_admin'],
      //   items: [
      //     {
      //       title: 'List',
      //       url: '/push-notifications',
      //     },
      //     {
      //       title: 'Send New',
      //       url: '/push-notifications/new',
      //     },
      //   ],
      // },
    ],
  },
  {
    label: 'WEBSITE & APP',
    access: [
      'super_admin',
      'support'
    ],
    items: [
      {
        title: 'Blog',
        icon: Icons.Alphabet,
        color: 'pink',
        access: ['super_admin', 'support'],
        items: [
          {
            title: 'Categories',
            url: '/blog/category',
            access: ['super_admin', 'support'],
          },
          {
            title: 'Articles',
            url: '/blog/articles',
            access: ['super_admin', 'support'],
          },
          {
            title: 'Add Article',
            url: '/blog/new',
            access: ['super_admin', 'support'],
          },
        ],
      },
      {
        title: 'Dynamic Pages',
        icon: Icons.Table,
        color: 'cyan',
        access: ['super_admin', 'support'],
        items: [
          {
            title: 'Folders/Groups',
            url: '/website/folders',
            access: ['super_admin', 'support'],
          },
          {
            title: 'Pages',
            url: '/website/pages',
            access: ['super_admin', 'support'],
          },
          {
            title: 'Add Page',
            url: '/website/add',
            access: ['super_admin', 'support'],
          },
        ],
      },
      // {
      //   title: 'App Min Version',
      //   url: '/min-version',
      //   items: [],
      //   icon: Icons.FourCircle,
      //   color: 'purple',
      //   access: ['super_admin'],
      // },
    ],
  },
] as const
